import $ from 'jquery'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

function init() {}
function ready() {
  const simpleFadeIn = () => {
    const $targets = $('.js-fadein')
    $targets.each((_, el) => {
      ScrollTrigger.create({
        trigger: el,
        start: 'top 70%',
        onEnter: () => el.classList.add('_anim'),
      })
    })
  }

  simpleFadeIn()
}

export default {
  init() {
    init()
    $(function () {
      ready()
    })
  },
}
